








import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";

interface PresenceItemInterface {
	icon: string;
	name: string;
	color: string;
}

@Component
export default class PresenceItem extends Vue {
	@Prop()
	presenceItem!: PresenceItemInterface;
}
